import { mutationTypes, actionTypes } from 'BASE/store/types'
import CONSTANT from 'BASE/common/chat/chat.constant'
import SETTING from 'BASE/common/chat/chat.setting'
import UTIL from 'BASE/common/chat/chat.util'
import PerfectScrollbar from 'perfect-scrollbar'

import room_message from 'BASE/components/chat/chat.base.component.roomMessage'

export default {
    directives: {
        pasteImage: {
            bind(el, binding) {
                el.addEventListener('paste', async (event) => {
                    const clipboardData = event.clipboardData || window.clipboardData;
                    const file = clipboardData.files[0];
                    if (file) {
                        el.blur();
                        binding.value.updatePreviewPasteImage(file);
                    }
                });
            }
        }
    },
    props: {
        prop_window: Object,
        prop_drag_window: HTMLDivElement,
    },
    components: {
        room_message,
    },
    data: function () {
        return {
            isSystemRoom: this.prop_window.room.type === CONSTANT.roomType.SYSTEM,
            isCustomerServiceRoom: this.prop_window.room.type === CONSTANT.roomType.CUSTOMER_SERVICE,
            isGroupRoom: this.prop_window.room.type === CONSTANT.roomType.DESCENDANT_GROUP,
            maxContentSize: SETTING.MESSAGE_CONTENT_MAX_SIZE,
            myUserId: this.$store.state.chat.userId,
            isGroupRoomAdmin: false,
            isShowInputBar: !this.prop_window.room.isReadOnly,
            room: this.prop_window.room,
            isShowEmotion: false,
            inputMessage: "",
            messageLength: 0,
            isInputDisabed: false,
            isInputFocus: true,
            messageScroll: undefined,
            messagePs: undefined,
            options: {
                isCustomizedScrollbar: false,
                isTriggerEmotionUpdateScrollbar: false,
            }
        };
    },
    methods: {
        sendMessage: async function (event) {
            if (event.shiftKey) {
                // shift+enter做換行
                return;
            }
            event.preventDefault();

            if (this.inputMessage === "") {
                return;
            }

            await this.$store.dispatch(actionTypes.CHAT_SEND_MESSAGE, {
                roomId: this.prop_window.room.id,
                type: CONSTANT.messageType.TEXT,
                content: this.inputMessage,
                connectionParams: {
                    waitConnected: true,
                    loading: this.$loading,
                },
            });
            this.inputMessage = "";
            this.isInputFocus = true;
        },
        sendEmotion: async function (n) {
            await this.$store.dispatch(actionTypes.CHAT_SEND_MESSAGE, {
                roomId: this.prop_window.room.id,
                type: CONSTANT.messageType.EMOTION,
                content: SETTING.EMOTION_NAME_PREFIX + n,
                connectionParams: {
                    waitConnected: true,
                    loading: this.$loading,
                },
            });
        },
        uploadImage: async function (event) {
            // 關閉訊息輸入
            this.isInputDisabed = true;

            await this.$store.dispatch(actionTypes.CHAT_UPLOAD_IMAGE, {
                roomId: this.prop_window.room.id,
                files: event.target.files,
                connectionParams: {
                    waitConnected: true,
                    loading: this.$loading,
                },
            });
            event.target.value = "";

            // 開啟訊息輸入
            this.isInputDisabed = false;
        },
        clearHistoryMessage: async function (title) {
            let result = await this.$dialog.confirm(SETTING.messages.CLEAR_HISTORY_MESSAGE_HINT(), title ? { title: title } : {});
            if (result.state) {
                this.$store.dispatch(actionTypes.CHAT_SET_HISTORY_MESSAGE_CLEAR_TIME, {
                    roomId: this.prop_window.room.id,
                });
            }
        },
        closeWindow: function () {
            this.$store.dispatch(actionTypes.CHAT_CLOSE_ROOM_WINDOW, { roomId: this.prop_window.room.id });
        },
        triggerEmotion: function () {
            this.isShowEmotion = !this.isShowEmotion;
            if (this.options.isTriggerEmotionUpdateScrollbar) {
                this.$nextTick(() => UTIL.scrollbarBottom(this.messageScroll));
            }
        },
        updateScrollbar: function () {
            UTIL.scrollbarBottom(this.messageScroll);
        },
        afterChangeMessageLength: function () {
            UTIL.scrollbarBottom(this.messageScroll)
        },
        addGroupRoomAnnouncement: function () {
            this.$dialog.get("addGroupRoomAnnouncement").show({
                roomId: this.prop_window.room.id
            });
        },
        removeGroupRoomAnnouncement: function () {
            this.$dialog.get("removeGroupRoomAnnouncement").show({
                roomId: this.prop_window.room.id,
                announcementList: this.announcementList
            });
        },
        updatePreviewPasteImage: function (file) {
            this.$emit('updatePreviewPasteImage', { roomId: this.prop_window.room.id, file });
        },
    },
    computed: {
        isShow: function () {
            return this.prop_window.showTime !== undefined;
        },
        title: function () {
            return this.prop_window.room.name;
        },
        isReadOnly: function () {
            return this.prop_window.room.isReadOnly;
        },
        groupReadOnly: function () {
            return this.prop_window.room.groupReadOnly;
        },
        roomMemberContainer: function () {
            return this.$store.state.chat.roomMemberContainers.find((item) => item.room.id === this.prop_window.room.id);
        },
        messages: function () {
            let container = this.$store.state.chat.roomMessageContainers.find((item) => {
                return item.room.id === this.prop_window.room.id;
            });
            this.messageLength = container ? container.roomMessages.length : 0;
            return container ? container.roomMessages : [];
        },
        members: function () {
            return this.$store.state.chat.roomMemberContainers.find((item) => item.room.id === this.prop_window.room.id).roomMembers;
        },
        onlineCount: function () {
            let memberContainer = this.$store.state.chat.roomMemberContainers.find((item) => item.room.id === this.prop_window.room.id);
            let count = 0;
            memberContainer.roomMembers.forEach(item => {
                if (item.isOnline) {
                    ++count;
                }
            });
            return count;
        },
        announcement: function() {
            return this.prop_window.room.announcement;
        },
        announcementList: function() {
            try {
                return JSON.parse(this.announcement);
            } catch (e) {
                return [];
            }
        },
        announcementListDesc: function() {
            try {
                let list = JSON.parse(this.announcement);
                return list.sort(function(a, b) {
                    return b.Id - a.Id;
                });
            } catch (e) {
                return [];
            }
        },
        isGroupRoomManager: function() {
            //管理者權限會動態變更，所以需用computed偵測
            if (this.isGroupRoom) {
                let members = this.$store.state.chat.roomMemberContainers.find((item) => item.room.id === this.prop_window.room.id).roomMembers;
                let member = members.find((item) => item.userId === this.$store.state.chat.userId);
                return member && member.role === CONSTANT.roomMemberRole.MANAGER;
            }
            return false
        }
    },
    watch: {
        messageLength: {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (this.messagePs) {
                        this.messagePs.update();
                    }
                    this.$nextTick(() => this.afterChangeMessageLength());
                }
            }
        }
    },
    mounted: function () {
        if (this.$refs.scroll) {
            if (this.$refs.scroll instanceof HTMLElement) {
                this.messageScroll = this.$refs.scroll;
            } else {
                this.messageScroll = this.$refs.scroll[0];
            }

            if (this.options.isCustomizedScrollbar) {
                this.messagePs = new PerfectScrollbar(this.messageScroll, {wheelPropagation: false});
            }
        }
        if (this.prop_drag_window && this.$refs.dragHandle[0]) {
            UTIL.registerDragElement(this.prop_drag_window, this.$refs.dragHandle[0]);
        }

        // 初始化找出是否是群組聊天室 最大權限群主
        if (this.isGroupRoom) {
            let members = this.$store.state.chat.roomMemberContainers.find((item) => item.room.id === this.prop_window.room.id).roomMembers;
            let member = members.find((item) => item.userId === this.$store.state.chat.userId);
            this.isGroupRoomAdmin = member.role === CONSTANT.roomMemberRole.ADMIN;
        }
    }
};
